import Module from './ThemeProvider'

export default Module
